import useTrigger, {TriggerProps} from 'modules/reports/hooks/trigger'
import React from 'react'
import {StyledPopover} from './ReportsPopover.styles'

export type ReportsPopoverExtensionProps = {trigger: (props: TriggerProps) => React.ReactNode}

type Props = ReportsPopoverExtensionProps & {
  children: React.ReactNode
  'data-testid': string
}

function ReportsPopover(props: Props) {
  const {renderTrigger, renderContent} = useTrigger()

  return (
    <>
      {renderTrigger(props.trigger)}

      {renderContent(({id, opened, anchorEl, close}) => (
        <StyledPopover
          id={id}
          open={opened}
          anchorEl={anchorEl}
          onClose={close}
          data-testid={props['data-testid']}
        >
          {props.children}
        </StyledPopover>
      ))}
    </>
  )
}

export default ReportsPopover
